<template>
  <BaseTag :tone="tone" preset="primary">
    {{ $t(`search-filters.status.${status}`) }}
  </BaseTag>
</template>

<script>
import BaseTag from '@/components/base/BaseTag.vue';
import { getTenderStatusTone } from '@/util/tag-tones/tender-status-tag';

export default {
  name: 'TenderStatusTag',
  components: {
    BaseTag,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    tone() {
      return getTenderStatusTone(this.status);
    },
  },
};
</script>
